/* eslint-disable */
// TetrisSpinner.tsx
import React from 'react';
import { keyframes, styled } from '@stitches/react';

// Define default dimensions
const defaultWidth = 48;
const defaultHeight = 56;
const aspectRatio = defaultHeight / defaultWidth; // ≈ 1.1667

// Define keyframes for tetromino animations
const tetromino1 = keyframes({
  '0%, 40%': { transform: 'translate(0, 0)' },
  '50%': { transform: `translate(${defaultWidth / 2}px, -${defaultHeight / 4}px)` },
  '60%, 100%': { transform: `translate(${defaultWidth}px, 0)` }
});

const tetromino2 = keyframes({
  '0%, 20%': { transform: `translate(${defaultWidth}px, 0px)` },
  '40%, 100%': { transform: `translate(${defaultWidth * 1.5}px, ${defaultHeight / 4}px)` }
});

const tetromino3 = keyframes({
  '0%': { transform: `translate(${defaultWidth * 1.5}px, ${defaultHeight / 4}px)` },
  '20%, 60%': { transform: `translate(${defaultWidth}px, ${defaultHeight / 2}px)` },
  '90%, 100%': { transform: `translate(${defaultWidth / 2}px, ${defaultHeight / 4}px)` }
});

const tetromino4 = keyframes({
  '0%, 60%': { transform: `translate(${defaultWidth / 2}px, ${defaultHeight / 4}px)` },
  '90%, 100%': { transform: 'translate(0, 0)' }
});

// Styled components
const TetrisContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const Tetrominos = styled('div', {
  position: 'relative',
  transformOrigin: 'center'
});

const Tetromino = styled('div', {
  position: 'absolute',
  transition: 'all ease .3s',
  background: `url('data:image/svg+xml;utf-8,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612 684"%3E%3Cpath fill="%23010101" d="M305.7 0L0 170.9v342.3L305.7 684 612 513.2V170.9L305.7 0z"/%3E%3Cpath fill="%23fff" d="M305.7 80.1l-233.6 131 233.6 131 234.2-131-234.2-131"/%3E%3C/svg%3E') no-repeat top center`,
  backgroundSize: 'contain'
});

const Box1 = styled(Tetromino, {
  animation: `${tetromino1} 1.5s ease-out infinite`
});

const Box2 = styled(Tetromino, {
  animation: `${tetromino2} 1.5s ease-out infinite`
});

const Box3 = styled(Tetromino, {
  animation: `${tetromino3} 1.5s ease-out infinite`,
  zIndex: 2
});

const Box4 = styled(Tetromino, {
  animation: `${tetromino4} 1.5s ease-out infinite`
});

// Spinner Props Interface
interface TetrisSpinnerProps {
  width?: number;
  // Remove height to maintain aspect ratio
}

export const TetrisSpinner: React.FC<TetrisSpinnerProps> = ({ width = defaultWidth }) => {
  // Compute height based on width to maintain aspect ratio
  const computedHeight = width * aspectRatio;
  const scale = width / defaultWidth;

  return (
    <TetrisContainer>
      <Tetrominos
        style={{
          width: `${width}px`,
          height: `${computedHeight}px`,
          transform: `scale(${scale})`
        }}
      >
        <Box1 style={{ width: `${defaultWidth}px`, height: `${defaultHeight}px` }} />
        <Box2 style={{ width: `${defaultWidth}px`, height: `${defaultHeight}px` }} />
        <Box3 style={{ width: `${defaultWidth}px`, height: `${defaultHeight}px` }} />
        <Box4 style={{ width: `${defaultWidth}px`, height: `${defaultHeight}px` }} />
      </Tetrominos>
    </TetrisContainer>
  );
};
